import springReportsApi from '../../services/springReportsApi'

export const getSmsSends = params => (
	new Promise((resolve, reject) => {
		springReportsApi()
			.get('/sms_sends', {params})
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)